import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/**
 * Confirm sheet for leaving the court queue (DELETE /queue/{entry_id}).
 *
 * Leaving forfeits your place — the backend rebalances everyone behind you — so
 * it requires an explicit confirm. The trigger only OPENS this sheet; `onLeave`
 * fires the network call, `onCancel` keeps the player's place and makes no call.
 */
export function LeaveQueueSheet({
  onLeave,
  onCancel,
  leaving,
  canLeave,
  error,
}: {
  onLeave: () => void;
  onCancel: () => void;
  leaving: boolean;
  canLeave: boolean;
  error: string | null;
}) {
  return (
    <Dialog
      open
      onClose={() => {
        if (!leaving) onCancel();
      }}
      aria-labelledby="leave-q-title"
      fullWidth
      maxWidth="xs"
      sx={{ "& .MuiButton-root.Mui-disabled": { pointerEvents: "auto" } }}
    >
      <DialogTitle id="leave-q-title">Leaving the queue</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure? You&apos;ll lose your place in line and have to rejoin
          at the back.
        </DialogContentText>
        {error ? (
          <Alert severity="error" role="alert" sx={{ mt: 2 }}>
            {error}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={onCancel} disabled={leaving} autoFocus>
          Keep my place
        </Button>
        <Button
          type="button"
          variant="contained"
          color="error"
          onClick={onLeave}
          disabled={leaving || !canLeave}
        >
          {leaving ? "Leaving…" : "Yes, leave"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
